<template>
    <div class="horizontal-menu-wrapper d-xl-none">
        <div class="main-menu menu-light menu-fixed menu-shadow" role="navigation"  data-menu-type="floating-nav">
            <div class="navbar-container main-menu-content" data-menu="menu-container">
                <ul class="nav navbar-nav" data-menu="menu-navigation">
                    <template v-if="clientStore.menu">
                        <li class="nav-item" v-for="(menu,index) in clientStore.menu" :key='index'>
                            <router-link
                                :to="{ name:  menu.name }"
                                class="nav-link d-flex align-items-center"
                                target="_self"
                                style="position: relative;"
                                v-if="menu.name !== 'client-logout'"
                            >
                                <div class="new-message" v-if="menu.name == 'client-message'"></div>
                                <vue-feather class="mr-50" :type="menu.icon"></vue-feather>
                                <span>{{ menu.title }}</span>
                            </router-link>
                            <a
                                :href="`#`"
                                class="nav-link d-flex align-items-center px-2"
                                target="_self"
                                style="position: relative;"
                                @click="logout"
                                v-else
                            >
                                <div class="new-message" v-if="menu.name == 'client-message'"></div>
                                <vue-feather class="mr-50" :type="menu.icon" ></vue-feather>
                                <span>{{ menu.title }}</span>
                            </a>

                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
    <nav class="header-navbar navbar-expand-lg navbar navbar-fixed align-items-center navbar-shadow navbar-brand-center">
        <div class="navbar-container d-flex main-menu-content">
            <ul class="nav navbar-nav navbar-collapse d-none d-xl-flex">
                <template v-if="clientStore.menu">
                    <li class="nav-item horizontal" v-for="(menu,index) in clientStore.menu" :key='index'>
                        <a
                            :href="`#`"
                            class="nav-link d-flex align-items-center px-2"
                            target="_self"
                            v-if="menu.name == 'client-logout'"
                            style="position: relative;"
                            @click="logout"
                        >
                            <div class="new-message" v-if="menu.name == 'client-message'"></div>
                            <vue-feather class="mr-50" :type="menu.icon" size="16"></vue-feather>
                            <span>{{ menu.title }}</span>
                        </a>
                        <router-link
                            :to="{ name: menu.name}"
                            class="nav-link d-flex align-items-center px-2"
                            target="_self"
                            style="position: relative;"
                            v-else
                        >
                            <div class="new-message" v-if="menu.name == 'client-message'"></div>
                            <vue-feather class="mr-50" :type="menu.icon" size="16"></vue-feather>
                            <span>{{ menu.title }}</span>
                        </router-link>

                    </li>
                </template>
            </ul>
            <div class="bookmark-wrapper d-flex align-items-center">
            <ul class="nav navbar-nav d-lg-none">
                <li class="nav-item"><a class="nav-link menu-toggle" href="javascript:void(0);"><i class="ficon" data-feather="menu"></i></a></li>
            </ul>
            </div>
            <ul class="nav navbar-nav align-items-center ml-auto">
                <li class="nav-item" id="append_tour_control"></li>
            <li class="nav-item dropdown dropdown-user" id="profile_step">
                <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="javascript:void(0);" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="user-nav d-sm-flex d-none">
                    <span class="user-name font-weight-bolder">{{ userStore.user.firstname}} {{  userStore.user.lastname}}</span>
                    <span class="user-status">{{ userStore.user.email }}</span>
                </div>
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-user">
                    <router-link
                        :to="{ name: 'client-plans'}"
                        aria-current="page"
                        class="dropdown-item"
                        target="_self"
                    >
                        <vue-feather class="mr-20" type="dollar-sign" size="15"></vue-feather>
                        <span>{{ localizationStore.translate('plans') }}</span>
                    </router-link>
                    <div class="dropdown-divider"></div>
                    <a
                        class="dropdown-item"
                        href="#"
                        @click="
                            logout()
                        "
                    >
                        <i class="mr-50" data-feather="power"></i> Logout
                    </a>
                </div>
            </li>
        </ul>
        </div>
    </nav>
</template>
<script>
    import { useClientStore } from "../../../stores/ClientStore.js";
    import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
    import { useUserStore } from "../../../stores/UserStore.js";
    export default {
        setup(){
            return{
                clientStore : useClientStore(),
                localizationStore: useLocalizationStore(),
                userStore : useUserStore()
            }
        },
        mounted(){

        },
        methods:{
            logout() {
                const route = this.$router.resolve({ name: 'client-logout'}).href;
                let $this = this;
                axios.get(route)
                .then(function (response) {
                    if(!response.data.error){
                        window.location.href = $this.$router.resolve({ name: 'client-login'}).href;
                    }
                    localStorage.clear();
                });
            }
        }
    }
</script>
<style>
li.horizontal{
    height: 42px;
    width: auto;
}
li.nav-item.horizontal a {
    height: 100%;
}
.horizontal .router-link-active{
    position: relative;
    background: linear-gradient(118deg, #4b9a5e, rgba(53, 138, 73, 0.7));
    box-shadow: 0 0 10px 1px rgba(53, 138, 73, 0.7);
    height: 100%;
    border-radius: 6px;
    color: white !important;
}
</style>
